module.exports = __webpack_public_path__ + "img/top1.1c6f98ed.png";